import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import '../../assets/scss/pages/authentication.scss'
import { IMAGE } from '../../configs/app-configs'
import Login from './Login'
import { useHistory } from 'react-router-dom'
import Register from './Register'
import ForgotPassword from './ForgotPassword'
import CreatePassword from './CreatePassword'
import LandingHeader from './LandingHeader'
import LandingFooter from './LandingFooter'
import styled from 'styled-components'
import { devices } from '../../configs/styles'

const PagetStyle = styled.div`
  height: 100%;
  .landing-page {
    background-image: url('${IMAGE.LANDING_PAGE_BG}');

    @media ${devices.laptop} {
      background-image: url('${IMAGE.LANDING_PAGE_TABLET_BG}');
    }
  }
`

const LandingPage = (props) => {
  const [activeTab, setActiveTab] = useState('')
  const history = useHistory()

  useEffect(() => {
    setActiveTab(props.activeTab || 'login')
  }, [props.activeTab])

  const TabView = () => {
    switch (activeTab) {
      case 'login':
        return <Login />
      case 'register':
        return <Register />
      case 'forgot-password':
        return <ForgotPassword />
      case 'reset-password':
      case 'provide-new-password':
        return <CreatePassword />
      default:
        return ''
    }
  }

  const goToLink = (link) => history.push(link)

  return (
    <PagetStyle>
      <div className='landing-page'>
        <div className='position-absolute w-100'/>
        <div className='ld-main'>
          <div className='ld-header d-flex justify-content-between mb-1 mb-md-3 mb-xl-5'>
            <LandingHeader />
          </div>
          <div className='lg-content-header d-flex cursor-pointer'>
            <div
              onClick={() => goToLink('/login')}
              className={classnames('col-6 text-center tab-control', {
                active: activeTab === 'login'
              })}
            >
              <FormattedMessage id='login' />
            </div>
            <div
              onClick={() => goToLink('/register')}
              className={classnames('col-6 text-center tab-control', {
                active: activeTab === 'register'
              })}
            >
              <FormattedMessage id='register' />
            </div>
          </div>
          <div className='lg-content p-2 p-md-4 p-lg-5'>
            <TabView />
          </div>
        </div>
        <LandingFooter />
      </div>
    </PagetStyle>
  )
}

export default LandingPage
